import { DISABLE_ACCOUNT_ERROR, DISABLE_ACCOUNT_SUCCESS } from 'actions';
import { DisableAccountActionTypes } from 'actionsConstants';
import { hitApi, ObservableAjax } from '__common/utils/api';
import { safeOfType as ofType } from '__common/utils/safeOfType';
import { switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

export function disableAccount(action$: Observable<any>) {
  return action$.pipe(
    ofType(DisableAccountActionTypes.DISABLE_ACCOUNT),
    switchMap(action =>
      ObservableAjax({
        until$: action$.pipe(ofType(DisableAccountActionTypes.DISABLE_ACCOUNT)),
        onSuccess: DISABLE_ACCOUNT_SUCCESS,
        onError: DISABLE_ACCOUNT_ERROR,
        onErrorMessage: 'Cannot deactivate user',
        link: hitApi('put', 'api/auth/deactivate/'),
      }),
    )
  );
}
